import AuthUtils from './auth_utils'; 

const useLogout = () => {
    const logout = () => {
        AuthUtils.ClearAuthToken(); 
        window.location.href = '/';
    };
    return logout;
};

export default useLogout;
